const FENCE = /^\s*(```|~~~)/;
// a paragraph holding only a non-breaking space: one visible empty line
const EMPTY_LINE = '&nbsp;';

// commonmark folds any run of blank lines into a single paragraph break. authors
// expect two enters to leave a visible gap, so every blank line beyond the first
// becomes an empty paragraph. fenced code keeps its blank lines untouched
function keepBlankLinesOutsideFences(lines) {
  const out = [];
  let inFence = false;
  let blankRun = 0;
  for (const line of lines) {
    if (FENCE.test(line)) inFence = !inFence;
    const blank = !inFence && line.trim() === '';
    if (blank) {
      blankRun += 1;
      // the first blank line is the paragraph break itself; extras become gaps
      if (blankRun > 1) out.push(EMPTY_LINE, '');
      else out.push('');
      continue;
    }
    blankRun = 0;
    out.push(line);
  }
  return out;
}

/**
 * makes extra blank lines in authored markdown show as vertical space instead
 * of collapsing into one paragraph break
 * @param markdown - raw markdown string
 */
export default function keepBlankLines(markdown) {
  if (!markdown || !/\n\s*\n\s*\n/.test(markdown)) return markdown;
  return keepBlankLinesOutsideFences(markdown.split('\n')).join('\n');
}
